import { ReactNode } from 'react';
import ChevronUpIcon from '@app/assets/icons/chevron-down.svg?react';
import ChevronDownIcon from '@app/assets/icons/chevron-down.svg?react';

interface SortableHeaderProps {
  label: string;
  field: string;
  currentSortBy?: string;
  currentSortOrder?: 'asc' | 'desc';
  onSort: (field: string) => void;
  children?: ReactNode;
  className?: string;
}

export const SortableHeader = ({
  label,
  field,
  currentSortBy,
  currentSortOrder,
  onSort,
  children,
  className
}: SortableHeaderProps) => {
  const isActive = currentSortBy === field;
  
  return (
    <th
      className={`p-4 text-xs font-medium text-left text-base-coolGray uppercase cursor-pointer transition-colors ${className || ''}`}
      onClick={() => onSort(field)}
    >
      <div className="flex items-center gap-2">
        <span>{label}</span>
        <div className="flex flex-col -space-y-2">
          <ChevronUpIcon 
            className={`w-4 h-4 transform rotate-180 ${isActive && currentSortOrder === 'asc' ? 'text-blue-600' : 'text-gray-400'}`} 
          />
          <ChevronDownIcon 
            className={`w-4 h-4 ${isActive && currentSortOrder === 'desc' ? 'text-blue-600' : 'text-gray-400'}`} 
          />
        </div>
      </div>
      {children}
    </th>
  );
};
